import PropTypes from "prop-types";
import "./ValidationError.css";

export const ValidationError = ({ id, messages }) => {
  const messageList = (Array.isArray(messages) ? messages : [messages]).filter(
    Boolean
  );

  return (
    <div id={id} className="validation-error">
      {messageList.map((m) => (
        <div key={m}>{m}</div>
      ))}
    </div>
  );
};

ValidationError.propTypes = {
  id: PropTypes.string,
  messages: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
};
